import { Outlet } from 'react-router-dom';

import { PageDetailContent } from '@client/toolkit';

import { CommercialSpacesListCard } from '../../../components/commercial-spaces-list-card/commercial-spaces-list-card.component';
import { CommonAreasListCard } from '../../../components/common-areas-list-card/common-areas-list-card.component';
import { ParkingSpotsListCard } from '../../../components/parking-spots-list-card/parking-spots-list-card.component';
import { PageContentAnimation } from '../../../../../components/layout/page-content-animation';

export function SpaceArealerRoute() {
  return (
    <>
      <PageDetailContent align="left">
        <PageContentAnimation>
          <div className="space-y-2">
            <CommercialSpacesListCard />
            <CommonAreasListCard />
            <ParkingSpotsListCard />
          </div>
        </PageContentAnimation>
      </PageDetailContent>
      <Outlet />
    </>
  );
}
